export var initAcTooltips = function () {
    document.querySelectorAll('[data-ac-tip]').forEach(function (element) {
        new Tooltip(element);
    });
};
var Tooltip = /** @class */ (function () {
    function Tooltip(el, content) {
        if (content === void 0) { content = ''; }
        this.element = el;
        this.content = content ? content : el.dataset.acTip;
        this.tip = createTooltip(this.content);
        this.initEvents();
    }
    Tooltip.prototype.initEvents = function () {
        var _this = this;
        if (this.element.dataset.acTooltipInit === '1') {
            return;
        }
        this.element.dataset.acTooltipInit = '1';
        document.body.appendChild(this.tip);
        this.element.addEventListener('mouseenter', function () {
            var bodyOffset = document.body.getBoundingClientRect();
            var viewportOffset = _this.element.getBoundingClientRect();
            _this.tip.style.left = ((viewportOffset.left - bodyOffset.left) + _this.element.offsetWidth / 2) + 'px';
            _this.tip.style.top = ((viewportOffset.top - bodyOffset.top) + _this.element.offsetHeight) + 'px';
            _this.tip.classList.add('hover');
        });
        this.element.addEventListener('mouseleave', function () {
            _this.tip.classList.remove('hover');
        });
    };
    return Tooltip;
}());
export { Tooltip };
var createTooltip = function (content) {
    var tip = document.createElement('div');
    tip.classList.add('ac-tooltip');
    tip.innerHTML = content;
    return tip;
};
